import { Button } from 'components/v4';

function LinkButton({ colorScheme = 'messenger', children, ...props }) {
    return (
        <Button
            variant="link"
            colorScheme={colorScheme}
            fontWeight={500}
            color={`${colorScheme}.500`}
            _hover={{
                color: `${colorScheme}.600`,
                textDecoration: 'underline',
            }}
            _focus={{
                boxShadow: 'none',
            }}
            {...props}>
            {children}
        </Button>
    );
}

export { LinkButton };
